import { createSelector } from 'reselect'
import { selectors as importedSelectors } from '../../imports'

export const getLauncherText = state => state.loadingBarReducer.texts.launcher
export const getVersionText = state => state.loadingBarReducer.texts.version
export const getPatchNotesText = state => state.loadingBarReducer.texts.patchNotes

const getActiveServerName = state => importedSelectors.getActiveServerName(state)
const getActiveEveClient = state => importedSelectors.getActiveEveClientVersion(state)
export const getClientText = createSelector(
    [getActiveServerName, getActiveEveClient, getVersionText],
    (serverName, clientVersion, versionText) => {
        if (serverName !== '' && clientVersion !== -1) {
            return versionText.replace('{server}', serverName).replace('{version}', clientVersion)
        }
        return ''
    },
)

export const getPatchNotes = createSelector(
    [getActiveServerName, getActiveEveClient, getPatchNotesText],
    (serverName, clientVersion, patchNotes) => {
        if (serverName !== '' && clientVersion !== -1) {
            return patchNotes
        }
        return null
    },
)



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/texts/selectors.js